export default __webpack_public_path__ + "static/media/rockwellAutomation.3e3d0e80.png";